module.exports = __webpack_public_path__ + "static/media/home-card1.a5772f6a.png";